import { marked } from "marked";

/**
 * Parse markdown string to HTML for UI components
 * @param chatAnswer
 */
export const parseMDStringToHtml = (
  chatAnswer: string
): string | Promise<string> => {
  // Convert markdown to HTML using marked
  return marked(chatAnswer);
};
